import axiosInstance from "../config/axiosConfig";

export const addVisitor = (body) => {
    try {
        return axiosInstance.post("/api/visitor", body);
    } catch (err) {
        throw err;
    }
};
